import LoginForm from '../../components/auth/login-form';

export const Login = () => {
	return <LoginForm />
}
